import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function MottoPolicy() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const principles = [
    { key: "transparency" },
    { key: "accountability" },
    { key: "antiCorruption" },
    { key: "quality" },
  ];

  const policies = [
    { key: "motto" },
    { key: "communityFirst" },
    { key: "verification" },
    { key: "refund" },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <section className="bg-gradient-to-b from-cyan-50 to-white border-b">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <p className="text-xs tracking-widest text-cyan-700 font-semibold uppercase">
            {t("motto.heroEyebrow")}
          </p>

          <h1 className="mt-3 text-4xl md:text-5xl font-extrabold text-gray-900">
            {t("motto.heroTitle")}
          </h1>

          <p className="mt-4 max-w-2xl text-gray-600 text-lg">
            {t("motto.heroDesc")}
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <button
              onClick={() => navigate("/report")}
              className="px-5 py-2 rounded-lg bg-gray-900 text-white hover:bg-gray-800"
            >
              {t("motto.ctaReport")}
            </button>

            <button
              onClick={() => navigate("/reports")}
              className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              {t("motto.ctaBrowse")}
            </button>
          </div>
        </div>
      </section>

      {/* Principles */}
      <section className="max-w-7xl mx-auto px-6 py-14">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
          {t("motto.principlesTitle")}
        </h2>
        <p className="mt-2 text-gray-600">{t("motto.principlesDesc")}</p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {principles.map((p) => (
            <div key={p.key} className="bg-white border rounded-2xl p-6 shadow-sm">
              <h3 className="font-semibold text-gray-900">
                {t(`motto.principles.${p.key}.title`)}
              </h3>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                {t(`motto.principles.${p.key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Policies */}
      <section className="bg-gray-50 border-t">
        <div className="max-w-7xl mx-auto px-6 py-14">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
            {t("motto.policiesTitle")}
          </h2>
          <p className="mt-2 text-gray-600">{t("motto.policiesDesc")}</p>

          <div className="mt-8 space-y-4">
            {policies.map((item) => (
              <details key={item.key} className="bg-white border rounded-2xl p-5 shadow-sm">
                <summary className="cursor-pointer font-semibold text-gray-900">
                  {t(`motto.policies.${item.key}.q`)}
                </summary>
                <p className="mt-3 text-gray-600 text-sm leading-relaxed">
                  {t(`motto.policies.${item.key}.a`)}
                </p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
